/**
 * @Author: zb
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-08-08 19:37:56
 * @LastEditTime: 2019-09-30 11:02:20
 * @Version: 1.0
 * @Description: 货源信息的校验规则
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 */

// 验证数字必须大于0, 且整数位长度不大于6， 小数位不大于4
export const validateNumber = (rule, value, callback) => {
  if (!value || value == 'null' || value == '') {
    callback()
  } else {
    const reg = /^[+]{0,1}[1-9]{1}(\d{0,5})$|^[+]{0,1}(\d{1,6}\.\d{1,4})$/
    if (reg.test(value) === false) {
      callback(new Error('请输入正确内容(正数、包括小数), 整数位最多6位，小数位最多4位'))
    } else {
      callback()
    }
  }
}

import validate, { isNormalStringValidator, isNormalString } from '@/utils/validate'
import { DatabaseUtil } from '@/utils/databaseUtils'
const dataBase = new DatabaseUtil()

// 理化性质校验
const validatePhysicalProperty = (rule, value, callback) => {
  const physicalProperty = JSON.parse(dataBase.sessionStorageUtil.get('physicalProperty'))
  if (!(!value || value == '')) {
    const dataItem = value.split(',')
    const assingable = dataItem.filter(el => !(!el || el == 'null' || el == ''))
    for (let i = 0; i < assingable.length; i++) {
      const element = assingable[i]
      const kv = element.split('@')
      let label = null   
      if (!isNormalString(kv[1].toString(), undefined)) {
        const index = Number.parseInt(kv[0]) - 1
        label = physicalProperty[index]['label'] && physicalProperty[index]['label'].split('@').length !== 0 && physicalProperty[index]['label'].split('@')[0]
        if(label !== '温度'){
          return callback(Error(`${label}只能填写数字`))
        }
      }
      const maxLength = 10
      if (kv[1].toString().length > maxLength) {
        const index = Number.parseInt(kv[0]) - 1
        label = physicalProperty[index]['label'] && physicalProperty[index]['label'].split('@').length !== 0 && physicalProperty[index]['label'].split('@')[0]
        return callback(Error(`${label}最大长度为${maxLength}字符`))
      }
    }
  }
  callback()
}

// 验证当前时间是否是最新时间
const validateNewestTime = (rule, value, callback) => {
  if (!(!value || value == '')) {
    if (value < Date.now() - 60 * 1000) {
      callback(Error('起运时间不能早于当前时间'))
    }
  }
  callback()
}

export const requiredRules = {
  goodsType: [{ required: true, message: '必填' }],
  contacter: [{ required: true, message: '必填' },
    { validator: isNormalStringValidator, trigger: 'blur' },
    { max: 10, message: '长度最大 10 个字符', trigger: 'blur' }
  ],
  startPlace: [{ required: true, message: '必填' }],
  stopPlace: [{ required: true, message: '必填' }],
  // startPlaceDetail: [{ validator: isNormalStringValidator, trigger: 'blur' }],
  // stopPlaceDetail: [{ validator: isNormalStringValidator, trigger: 'blur' }],
  expectPrice: [{ required: true, message: '必填' },
    { validator: validateNumber, trigger: 'blur' }
  ],
  expectPrice2: [],
  goodsName: [{ required: true, message: '必填' },
    { validator: isNormalStringValidator, trigger: 'blur' },
    { max: 100, message: '长度最大 100 个字符', trigger: 'blur' }
  ],
  startTransportDate: [
    { required: true, message: '必填' },
    { validator: validateNewestTime, trigger: 'blur' }
  ],
  mostLateDeliveryDate: [
    { required: true, message: '必填' }
  ],
  singlePrice: [
    { required: true, message: '必填' },
    { validator: validateNumber, trigger: 'blur' }
  ],
  // capacity: [
  // { required: true, message: '必填' },
  // { validator: validateNumber, trigger: 'blur' }
  // ],
  weight: [{ required: true, message: '必填' },
    { validator: validateNumber, trigger: 'blur' }
  ],
  fileUrl: [
    // { required: true, message: '必填' }
  ],
  physicalProperty: [
    { required: true, message: '必填' },
    { validator: validatePhysicalProperty, trigger: 'blur' }
  ],
  contacterTel: [{ required: true, message: '必填' },
    { validator: isNormalStringValidator, trigger: 'blur' },
    { validator: validate('phone'), trigger: 'blur' }
  ],
  payType: [{ required: true, message: '必填' }],
  packageType: [{ required: true, message: '必填' }],
  transportType: [{ required: true, message: '必填' }],
  expireDate: [{ required: true, message: '必填' },
    { validator: validateNewestTime, trigger: 'blur' }],
  startPlaceDetail: [{ max: 100, message: '长度最大 100 个字符', trigger: 'blur' }],
  stopPlaceDetail: [{ max: 100, message: '长度最大 100 个字符', trigger: 'blur' }]
}

export const rules = {
  goodsName: [
    { validator: isNormalStringValidator, trigger: 'blur' },
    { max: 50, message: '长度最大 50 个字符', trigger: 'blur' }
  ],
  expectPrice: [
    { validator: validateNumber, trigger: 'blur' }
  ],
  expectPrice2: [{ message: '必填' }],
  // capacity: [
  //   { validator: validateNumber, trigger: 'blur' }
  // ],
  weight: [
    { validator: validateNumber, trigger: 'blur' }
  ],
  singlePrice: [
    { validator: validateNumber, trigger: 'blur' }
  ],
  physicalProperty: [
    { validator: validatePhysicalProperty, trigger: 'blur' }
  ],
  distance: [
    { validator: validateNumber, trigger: 'blur' }
  ],
  startTransportDate: [
    { validator: validateNewestTime, trigger: 'blur' }
  ],
  expireDate: [
    { validator: validateNewestTime, trigger: 'blur' }],
  contacterTel: [
    { validator: validate('phone'), trigger: 'blur' }
  ],
  contacter: [
    { validator: isNormalStringValidator, trigger: 'blur' },
    { max: 10, message: '长度最大 10 个字符', trigger: 'blur' }
  ],
  startPlaceDetail: [{ max: 100, message: '长度最大 100 个字符', trigger: 'blur' }],
  stopPlaceDetail: [{ max: 100, message: '长度最大 100 个字符', trigger: 'blur' }]
}
